import { Col, Container, Row } from "react-bootstrap";
import Particle from "../Particle";
import ExperienceCard from "./ExperienceCard";

function Experience() {
  return (
    <Container fluid className="experience-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Experience </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here's a summary of my past internships and work experience.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={12} className="project-card">
            <ExperienceCard
              role="Java Developer Intern"
              company="Infosys Springboard"
              duration="Oct 2024 – Dec 2024"
              description={[
                "Designed and developed a full-stack web application for managing and tracking user expenses using React and Spring Boot.",
                "Documented the project with detailed design and implementation notes.",
                "Contributed to both frontend and backend development, implementing core features, authentication, and data management.",
                "Selected as the team representative among five members to report progress updates regularly.",
              ]}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Experience;
